module.exports = __webpack_public_path__ + "static/img/logo_only.5fa67d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_only.png
// module id = VOnd
// module chunks = 1